import React, { useState } from "react";

import SidebarTransition from "@Shared/Components/MacroSidebar/SidebarTransition";
import {
  IllustrationContainer,
  IllustrationPreviewContainer,
  IllustrationsContainer,
} from "./styles";
import { ILLUSTRATIONS } from "./defaults";

const IllustrationPicker = ({ illustration, onChange = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IllustrationContainer
        onClick={() => setIsOpen(true)}
        illustration={illustration?.link}
      />

      <SidebarTransition
        isOpen={isOpen}
        position="right"
        close={() => setIsOpen(false)}
        width={400}
        containerStyles={{ top: "75px" }}
        additionalStyle={{
          padding: "0 13px 0 0",
        }}
        showTabs
        tabs={["Illustrations"]}
        selectedTab="Illustrations"
        setSelectedTab={() => {}}
        shouldHideScrollbar={!isOpen}
      >
        <IllustrationsContainer>
          {ILLUSTRATIONS.map((illustration) => (
            <IllustrationPreviewContainer
              onClick={() => {
                onChange(illustration);
                setIsOpen(false);
              }}
            >
              <img src={illustration.link} alt="Illustration" width="100%" />
            </IllustrationPreviewContainer>
          ))}
        </IllustrationsContainer>
      </SidebarTransition>
    </>
  );
};

export default IllustrationPicker;
